function productSlideHandle() {
    const sliderInit = isUpdate => {
            if (document.querySelectorAll(".product__media-gallery .js-media-list") && document.querySelectorAll(".product__media-gallery .js-media-list").length > 0) {

                let slider = new Swiper(".product__media-gallery .js-media-list", {
                    slidesPerView: 1,
                    autoHeight: true,
                    spaceBetween: 4,
                    navigation: false,
                    pagination: {
                        el: document.querySelector(".product__media-gallery .js-media-list .swiper-pagination"),
                        clickable: true,
                    },
                    thumbs: {
                        swiper: document.querySelector(".swiper-thumbs") ?  document.querySelector(".swiper-thumbs").swiper : null
                    },
                    on: {
                        slideChangeTransitionStart: function() {
                            document.querySelector(".swiper-thumbs").swiper.slideTo(document.querySelector(".product__media-gallery .js-media-list").swiper.activeIndex)
                        },
                        slideChange: function() {
                            window.pauseAllMedia(),
                                this.params.noSwiping = false
                        },
                        slideChangeTransitionEnd: function() {
                            this.slides[this.activeIndex].querySelector("model-viewer") && this.slides[this.activeIndex].querySelector(".shopify-model-viewer-ui__button--poster").removeAttribute("hidden")
                        },
                        touchStart: function(s, e) {
                            this.slides[this.activeIndex].querySelector("model-viewer") && (this.slides[this.activeIndex].querySelector("model-viewer").classList.contains("shopify-model-viewer-ui__disabled") || (this.params.noSwiping = !0,
                                this.params.noSwipingClass = "swiper-slide"))
                        }
                    }
                });
                isUpdate && setTimeout(function() {
                    slider.update()
                }, 800)
            }
        },
        subSliderInit = isUpdate => {
            if (document.querySelectorAll(".swiper-thumbs") && document.querySelectorAll(".swiper-thumbs").length > 0) {
                let subSlider = new Swiper(".swiper-thumbs", {
                    //centeredSlides: false,
                    centeredSlidesBounds: true,
                    slidesPerView: 4,
                    spaceBetween: 10,
                    direction: "horizontal",
                    navigation: {
                        nextEl: document.querySelector("[id^='GalleryThumbnails'] .swiper-button-next"),
                        prevEl: document.querySelector("[id^='GalleryThumbnails'] .swiper-button-prev"),
                    },
                    watchSlidesProgress: true,
                    on: {
                        touchEnd: function(s, e) {
                            let range = 5,
                                diff = s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY - s.touches.startY;
                            (diff < range || diff > -range) && (s.allowClick = true)
                        }
                    },
                    transitionStart: function() {
                        document.querySelector(".product__media-gallery .js-media-list").swiper.slideTo(document.querySelector(".swiper-thumbs").swiper.activeIndex)
                    },
                    breakpoints: {
                        768: {
                            direction: "vertical",
                            slidesPerView: 4,
                            spaceBetween: 10
                        }
                    }
                });
                isUpdate && setTimeout(function() {
                    subSlider.update()
                }, 800)
            }
        }

    function swiperInit() {
        subSliderInit(true);
        sliderInit(true);
    }

    document.addEventListener('shopify:section:load', function(e) {
        swiperInit();
    });

    swiperInit();

}
productSlideHandle();